/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/countries';
import '../../../bills/merchant';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "models": {
                    "nested": {
                      "Merchant": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "profileLogoUrl": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "locationName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": "squareup.common.countries.Country",
                            "id": 5,
                            "rule": "optional"
                          },
                          "taxProfile": {
                            "type": "squareup.bills.Merchant.DisplayDetails.TaxProfile",
                            "id": 6,
                            "rule": "optional"
                          },
                          "mobileStaffId": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "mobileStaffActive": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "Device": {
                        "fields": {
                          "deviceToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userAgent": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "deviceCredential": {
                            "type": "squareup.beemo.api.v2.models.Device.DeviceCredential",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "DeviceCredential": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ClientDetails": {
                        "fields": {
                          "device": {
                            "type": "squareup.beemo.api.v2.models.Device",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Customer": {
                        "fields": {
                          "userToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userImageUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreatorDetails": {
                        "fields": {
                          "mobileStaff": {
                            "type": "squareup.beemo.api.v2.models.MobileStaff",
                            "id": 1,
                            "rule": "optional"
                          },
                          "employee": {
                            "type": "squareup.beemo.api.v2.models.Employee",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Employee": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "active": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "employeeNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "firstName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "merchantToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "MobileStaff": {
                        "fields": {
                          "userToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "profilePhotoUrl": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "mobileStaffId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "active": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Merchant && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Device && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Device?.nested?.DeviceCredential && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ClientDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Customer && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.CreatorDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Employee && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.MobileStaff) {
  $root.addJSON(jsonData);
}

/**
 * An entity which can take a payment.
 *
 * SOURCE Merchant @ squareup/beemo/v2/models/users.proto at 12:1
 */
export const Merchant = $root.lookupType('squareup.beemo.api.v2.models.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * The device which records payments.
 *
 * SOURCE Device @ squareup/beemo/v2/models/users.proto at 42:1
 */
export const Device = $root.lookupType('squareup.beemo.api.v2.models.Device');
fixType(Device);
Builder.createAndAttachToType(Device);
/**
 * SOURCE DeviceCredential @ squareup/beemo/v2/models/users.proto at 53:3
 */
Device.DeviceCredential = $root.lookupType('squareup.beemo.api.v2.models.Device.DeviceCredential');
fixType(Device.DeviceCredential);
Builder.createAndAttachToType(Device.DeviceCredential);
/**
 * Client details.
 *
 * SOURCE ClientDetails @ squareup/beemo/v2/models/users.proto at 66:1
 */
export const ClientDetails = $root.lookupType('squareup.beemo.api.v2.models.ClientDetails');
fixType(ClientDetails);
Builder.createAndAttachToType(ClientDetails);
/**
 * An entity which pays a merchant
 *
 * SOURCE Customer @ squareup/beemo/v2/models/users.proto at 72:1
 */
export const Customer = $root.lookupType('squareup.beemo.api.v2.models.Customer');
fixType(Customer);
Builder.createAndAttachToType(Customer);
/**
 * Only one of these fields will be set.
 *
 * SOURCE CreatorDetails @ squareup/beemo/v2/models/users.proto at 87:1
 */
export const CreatorDetails = $root.lookupType('squareup.beemo.api.v2.models.CreatorDetails');
fixType(CreatorDetails);
Builder.createAndAttachToType(CreatorDetails);
/**
 * Employees represents the person who is taking action in one of Square's features.
 *
 * SOURCE Employee @ squareup/beemo/v2/models/users.proto at 98:1
 */
export const Employee = $root.lookupType('squareup.beemo.api.v2.models.Employee');
fixType(Employee);
Builder.createAndAttachToType(Employee);
/**
 * SOURCE MobileStaff @ squareup/beemo/v2/models/users.proto at 120:1
 */
export const MobileStaff = $root.lookupType('squareup.beemo.api.v2.models.MobileStaff');
fixType(MobileStaff);
Builder.createAndAttachToType(MobileStaff);